import UdeskLocales from 'UdeskLocales';
import React, { FC, useState } from 'react';
import { Button } from 'udesk-ui';
import { ArrowDownSOutlined } from '@udesk/icons';

interface TemplateProps {
    initialShow?: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { initialShow = false, children } = props;

    const [isShow, setIsShow] = useState(initialShow);
    const onShowToggle = () => {
        setIsShow(!isShow);
    };

    return (
        <>
            <Button type="link" onClick={onShowToggle}>
                <span>
                    {/* 相似问推荐 */}
                    {
                        UdeskLocales['current'].components.similarQuestionRecommend.index
                            .similarQuestionRecommendation
                    }
                </span>
                <ArrowDownSOutlined
                    style={{
                        transform: isShow ? 'rotate(180deg)' : '',
                        transformOrigin: '50% 50%',
                        transition: 'transform .3s',
                    }}
                />
            </Button>

            {isShow ? children : null}
        </>
    );
};

export default Template;
